/* eslint-disable ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import EmberObject, { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';

export default class GradeSchedulesController extends Controller {
  @action
  setFilterValue(value) {
    this.filterValue = value;
  }

  // Attrs
  @service
  permissions;

  @service
  store;

  Scopes = Scopes;

  // filterValue provides the params entered into the grade schedule filter box.
  @tracked filterValue = '';

  @tracked
  linkedModules = null;
  @tracked
  linkedAssessments = null;
  @tracked
  actionType = '';

  @tracked
  dialogOpen;

  @tracked
  editingSchedule;

  @tracked
  schedule;

  @tracked
  scheduleDialogOpen;

  // Methods
  /**
   * filteredGradeSchedules filters grade schedules based on the user's filter.
   */
  @computed('model.gradeschedules.[]', 'filterValue')
  get filteredGradeSchedules() {
    if (isEmpty(this.filterValue)) {
      return this.model.gradeSchedules;
    }

    return this.model.gradeSchedules.filter((gradeSchedule) => {
      return filterValue(
        gradeSchedule.label,
        DataType.STRING,
        this.filterValue,
      );
    });
  }

  // retrieveLinkedModules returns any modules that are linked to the grade schedule being deleted
  retrieveLinkedModules() {
    this.store
      .query('assessments/module', {
        gradeScheduleId: this.schedule.id,
      })
      .then((modules) => {
        this.linkedModules = modules;
      });
  }

  // retrieveLinkedAssessments returns any assessments that are linked to the grade schedule being deleted
  retrieveLinkedAssessments() {
    this.store
      .query('assessments/assessment', {
        gradeScheduleId: this.schedule.id,
      })
      .then((assessments) => {
        this.linkedAssessments = assessments;
      });
  }

  @computed('model.{assessments.[],modules.[],gradeSchedules.[]}')
  get gradeScheduleLinksMap() {
    let linksMap = EmberObject.create({});

    this.model.gradeSchedules.forEach((schedule) => {
      let scheduleId = schedule.get('id');

      linksMap[scheduleId] = [
        ...this.model.assessments.filter(
          (item) => item.gradeSchedule_id === scheduleId,
        ),
        ...this.model.modules.filter(
          (item) => item.gradeSchedule_id === scheduleId,
        ),
      ];
    });

    return linksMap;
  }

  @action
  noop() {}

  @action
  editSchedule(schedule) {
    this.editingSchedule = schedule;
    this.dialogOpen = true;
  }

  @action
  closeDialogs() {
    this.dialogOpen = false;
    this.scheduleDialogOpen = false;
  }

  @action
  openGradeScheduleActionDialog(schedule, actionType) {
    this.schedule = schedule;
    this.retrieveLinkedModules();
    this.retrieveLinkedAssessments();
    this.actionType = actionType;
    this.scheduleDialogOpen = true;
  }

  // Lifecycle Hooks
  // reset provides the controller call for the router to reset the controller.
  reset() {
    this.filterValue = '';
  }
}
